
<template>
  <div>
  <div class="cntnt" >

<div id="aiib" hidden>

    <h1 class="heading">  AIIB Project</h1>
    <p class="content">
    link
    </p>
  </div>
<div id="saubhagya">
  <b-row>
    <b-col cols="6">
        <h1 class="heading">SAUBHAGYA</h1>
    </b-col>
</b-row>
<p class="content">
<b-row>
  <b-col cols="12" class="iphone5font">
    <strong>(Pradhan Mantri Sahaj Bijli Har Ghar Yojana)</strong>
  </b-col>
</b-row>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <strong>Objective:</strong> To achieve universal household electrification in the country
  </b-col>
</b-row>
<strong>Target date:</strong> 31st March, 2019
<br><br>
<strong>Salient Features:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
  <ol>
    <li>The Scheme will cover both urban and rural areas</li>
    <li>In Assam, a total of 26.45 Lakhs of Households will be electrified (Rural: 24.80 Lakhs; Urban: 1.65 Lakhs)</li>
    <li>APDCL has developed a new Mobile App named "SANJOG" for providing connections under Saubhagya Scheme</li>
    <li>All new connections under Saubhagya Scheme will be released through the Mobile App</li>
    <li>The Mobile App has provision for taking photographs of beneficiaries as well as documents</li>
    <li>The Mobile App will also capture the GPS coordinates of the beneficiaries' houses</li>
    <li>Paper less connection process; no need to submit any physical documents</li>
    <li>No need to pay any charges at the time of connection</li>
  </ol>
</b-col>
</b-row>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <a target="_blank" href="https://saubhagya.gov.in/">Click here to view the latest status of Saubhagya Scheme</a>
  </b-col>
</b-row>
</p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
<div id="ipds">
  <b-row>
    <b-col cols="6">
      <h1 class="heading">IPDS</h1>
    </b-col>

 </b-row>

<p class="content">
<strong>  (Integrated Power Development Scheme)</strong>
<br>
<strong>Objective:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>Strengthening of sub-transmission and distribution network in the urban areas</li>
      <li>Metering of distribution transformers/feeders/consumers in the urban areas</li>
      <li>IT enablement of distribution sector and strengthening of distribution network</li>
    </ol>
  </b-col>
</b-row>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    The scheme will help in reduction in AT&C losses, establishment of IT enabled energy accounting/auditing system,
    improvement in billed energy based on metered consumption and improvement in collection efficiency.
  </b-col>
</b-row>
<strong>Present Status:</strong>
<br>
Works awarded:
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>New Sub-Station : 13 Nos.</li>
      <li>Capacity enhancement & Additional Transformers: 36 Nos.</li>
      <li>HT Lines (33 kV & 11 kV) : 616 CkM</li>
      <li>LT Lines : 211 CkM</li>
      <li>Aerial Bunched Cable / Underground: 2322 CkM</li>
      <li>New Distribution Transformers: 596 Nos.</li>
      <li>Consumer Meters: 68190 Nos.</li>
    </ol>
  </b-col>
</b-row>
<a target="_blank" href="https://www.ipds.gov.in/Default.aspx">Click here to view the latest status of IPDS Scheme</a>
</p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
<div id="ddugjy">
  <b-row>
    <b-col cols="6">
    <h1 class="heading">DDUGJY</h1>
    </b-col>
 </b-row>

 <p class="content">
   <strong>(Deen Dayal Upadhyaya Gram Jyoti Yojana)</strong>
<br>
<strong>Objective:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>To provide electrification to all villages</li>
      <li>Improvement of Sub-transmission and distribution network to improve the quality and reliability of the supply</li>
      <li>Metering to reduce the losses</li>
    </ol>
  </b-col>
</b-row>
<strong>Present Status:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>All 25,372 nos. of Census Villages have been electrified on 31.12.2017</li>
      <li>Sub-transmission and distribution network improvement work going on</li>
      <li>Metering at all levels (input points, feeders and distribution transformers etc.) going on</li>
    </ol>
  </b-col>
</b-row>
<a target="_blank" href="http://www.ddugjy.gov.in/">Click here to view the latest status of DDUGJY Scheme</a>
 </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
<div id="uday">
  <b-row>
    <b-col cols="6">
      <h1 class="heading">UDAY</h1>
    </b-col>
 </b-row>
 <p class="content">
   <strong>(Ujwal Discom Assurance Yojana)</strong>
<br>
<strong>Objective:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
      Improve the operational and financial efficiency of the State Power Distribution Companies (DISCOMs)
  </b-col>
</b-row>
<br>
<strong>Present Status:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>Tripartite MoU was signed between Govt. of India, Govt. of Assam and APDCL on 04.01.2017 (Click here to view the MoU)</li>
      <li>As per MoU, APDCL has proposed to reduce the AT&C losses & ACS-ARR Gap by 2019-20 as per the following trajectory:</li>
    </ol>
  </b-col>
</b-row>
<strong>AT&C Losses:</strong>
<table border class="tableWidth">
  <tr>
    <th>2016-17</th>
    <th>2017-18</th>
    <th>2018-19</th>
    <th>2019-20</th>
  </tr>
  <tr>
    <td>19.00%</td>
    <td>17.75%</td>
    <td>16.10%</td>
    <td>15.00%</td>
  </tr>
</table>
<strong>ACS-ARR Gap:</strong>
<table border class="tableWidth">
  <tr>
    <th>2016-17</th>
    <th>2017-18</th>
    <th>2018-19</th>
    <th>2019-20</th>
  </tr>
  <tr>
    <td>Rs. 0.66</td>
    <td>Rs. 0.43</td>
    <td>Rs. 0.19</td>
    <td>Rs. 0.05</td>
  </tr>
</table>
<br>
<a target="_blank" href="https://www.uday.gov.in/state.php?id=19&code=assam">Click here to view the latest status of UDAY Scheme</a>
 </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
  <div id="akashdeep">

      <h1 class="heading"> AKASHDEEP</h1>
      <p class="content">
      Under MMADY scheme of Government of Assam,
       LED bulbs will be distributed among applicable consumer base of APDCL.
       AKASHDEEP mobile app is an effort by APDCL to implement the scheme effectively as
       well as transparently.
      </p>
    </div>
    <br><br><br><br><br><br><br><br><br><br><br>
</div>
</div>
</template>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
  text-align: justify;
  line-height: 1.8rem;
  font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;
}
#vision{
  transition: 1s;
}
table{
  text-align: left !important;
}
.tableWidth{
  width: 500px;
}
@media (max-width: 576px) {
  .tableWidth{
    width: 340px;
  }
  .cntnt{
  box-shadow: none;
  }
}
</style>
<script>
export default {

}
</script>
